import React, { useState } from "react";
import { TextField, PrimaryButton, Stack, MessageBar, MessageBarType } from "@fluentui/react";
import axios from "axios";
import { Link } from "@fluentui/react-components";

const ResetPassword = (props) => {
  const [formData, setFormData] = useState({
    email: "",
    currentPassword: "",
    newPassword: "",
  });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleInputChange = (event, newValue) => {
    const { name } = event.target;
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    try {
      const response = await axios.post("/api/reset-password", formData);
      setMessage(response.data.message);
      setFormData({ email: "", currentPassword: "", newPassword: "" });
    } catch (err) {
      setError(err.response?.data?.error || "An error occurred.");
    }
  };

  return (
    <Stack
      tokens={{ childrenGap: 20, padding: 20 }}
      styles={{ root: { maxWidth: 400, margin: "auto" } }}
    >
      <h3>Reset Password</h3>
      {message && (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          {message} <Link href="#" onClick={() => props.history.push('/sign-in')}>Sign in now</Link>
        </MessageBar>
      )}
      {error && (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
          {error}
        </MessageBar>
      )}

      <TextField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleInputChange}
        required
      />
      <TextField
        label="Current Password or Reset Code"
        name="currentPassword"
        type="password"
        value={formData.currentPassword}
        onChange={handleInputChange}
        required
      />
      <TextField
        label="New Password"
        name="newPassword"
        type="password"
        value={formData.newPassword}
        onChange={handleInputChange}
        required
      />
      <PrimaryButton text="Reset Password" onClick={handleSubmit} />
    </Stack>
  );
};

export default ResetPassword;
